import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import StyledContent from './styled/content'
import StyledLabel from './styled/label'
import StyledSwitch from './styled/index'

const Switch = (props) => {
  const {
    style,
    className,
    backgroundColor,
    checked,
    disabled,
    onChange,
    label,
    // 默认值'md',还有'sm','lg'
    size = 'md',
  } = props
  if (label) {
    return (
      <StyledSwitch>
        <StyledContent
          data-id="switch-element"
          type="checkbox"
          className={clsx('checked:bg-primary', className)}
          style={style}
          checked={checked}
          backgroundColor={backgroundColor}
          disabled={disabled}
          onChange={onChange}
          size={size}
        />
        <StyledLabel label={label} disabled={disabled} size={size}>
          {label}
        </StyledLabel>
      </StyledSwitch>
    )
  }
  return (
    <StyledContent
      data-id="switch-element"
      type="checkbox"
      className={clsx('checked:bg-primary', className)}
      style={style}
      checked={checked}
      backgroundColor={backgroundColor}
      disabled={disabled}
      onChange={onChange}
      size={size}
    />
  )
}

// 参数类型
Switch.propTypes = {
  style: PropTypes.shape,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
}

Switch.defaultProps = {
  style: {},
  className: undefined,
  label: undefined,
  backgroundColor: undefined,
  disabled: false,
  checked: undefined,
  onChange: undefined,
  size: 'md',
}

export default Switch
